import * as React from 'react'
import { ReactElement, useMemo } from 'react'
import BaseFileOverview, { BaseFileOverviewProps, FileFilterType } from '../../../../pages/File/BaseFileOverview'

export default function CRMFileOverview(props: BaseFileOverviewProps): ReactElement {
    const fixedFilterValues = useMemo<FileFilterType>(
        () => ({
            ownerUsers: [],
            executiveUsers: [],
            crmRelations: [props.crmRelationId],
        }),
        [props.crmRelationId],
    )

    return <BaseFileOverview {...props} fixedFilterValues={fixedFilterValues} localStorageKeyPrefix={`HammockFileOverview-${props.crmRelationId}`} />
}
